<template>
  
<span>

	<Menu/>

	<b-row style="margin-top:125pt">
		<b-col>
			<b-overlay
				:show="true"
				opacity="0"
				variant="white"
				no-center>
				
				<b-carousel>
			
					<b-carousel-slide>

						<template v-slot:img>
							<b-img
							class="d-block img-fluid w-100"
							width="1024"
							height="480"
							:src="require('../../assets/stock/gray-desk-1.jpg')"
							alt="image slot"
							:rounded="true"/>



						</template>

						
						
					

					</b-carousel-slide>

				</b-carousel>

				
				<template v-slot:overlay>
					
					<div 
						class="d-flex h-100 align-items-center justify-content-left"
						style=" color:#FFFFFF">
						
							<p class="pl-3 display-4 d-none d-sm-block">
								Built for productive people <br/>
								(or those who want to be).
							</p>

							
							<p class="pl-3 display-4 d-sm-none">
								Built for productive people
								(or those who want to be).
							</p>

					</div>

				</template>
					
			
				
			
			</b-overlay>
		</b-col>
	</b-row>

	<b-row class="mt-5">
		<b-col>
			
			<h1 class="display-3">
				Principal Task
			</h1>

			<p style="font-size:1.25em;">
				Principal Task is todo list software without complexity.  Available on all of your devices &mdash; Mac or Windows, Android or iPhone &mdash;  
				it's ready any time you need to update your list or catch up on your day.
			</p>

			<p style="font-size:1.25em">
				Click or tap <b-link :to="{name: 'signup', params: {action: 'signup'}}">here</b-link> to get started.
				Scroll to learn more.
			</p>
		</b-col>
	</b-row>

	<b-row class="mt-5">
		<b-col>
			
			<b-card no-body class="overflow-hidden" style="border:none;">
				
				<b-row no-gutters>
					
					<b-col 
						md="8" 
						align-self="center"
						order="2"
						order-md="1">

						
						
						<b-card-body>
							
							<b-card-text>

								<h2 class="display-4">
									Stay Organized
								</h2>

								<p style="font-size:1.25em">
									Principal Task tracks all of the dimensions of your todos so that you can organize things your way.
								</p>
							</b-card-text>

							<b-list-group>
						

								<b-overlay
									:show="features.contexts"
									:opacity="opacity"
									:variant="variant">
									
									<b-list-group-item 
										class="d-flex justify-content-between align-items-center"
										@click="over('contexts')">

										Contexts
										<b-icon icon="at"/>
									</b-list-group-item>

									<template v-slot:overlay>
										{{featureText.contexts}}
									</template>

								</b-overlay>
								
								<b-overlay
									:show="features.folders"
									:opacity="opacity"
									:variant="variant">
									
									<b-list-group-item 
										class="d-flex justify-content-between align-items-center"
										@click="over('folders')">

										Folders
										<b-icon icon="folder"/>
									</b-list-group-item>

									<template v-slot:overlay>
										{{featureText.folders}}
									</template>

								</b-overlay>

								<b-overlay
									:show="features.nestedFolders"
									:opacity="opacity"
									:variant="variant">
									
									<b-list-group-item 
										class="d-flex justify-content-between align-items-center"
										@click="over('nestedFolders')">

										Nested Folders
										<b-icon icon="list-nested"/>
									</b-list-group-item>

									<template v-slot:overlay>
										{{featureText.nestedFolders}}
									</template>

								</b-overlay>

								<b-overlay
									:show="features.priorities"
									:opacity="opacity"
									:variant="variant">
									
									<b-list-group-item 
										class="d-flex justify-content-between align-items-center"
										@click="over('priorities')">

										Priority
										<b-icon icon="exclamation"/>
									</b-list-group-item>

									<template v-slot:overlay>
										{{featureText.priorities}}
									</template>

								</b-overlay>

								

								<b-overlay
									:show="features.stars"
									:opacity="opacity"
									:variant="variant">
								
									<b-list-group-item 
										class="d-flex justify-content-between align-items-center"
										@click="over('stars')">

										Star
										<b-icon icon="star"/>
									</b-list-group-item>

									<template v-slot:overlay>
										{{featureText.stars}}
									</template>

								</b-overlay>

								<b-overlay
									:show="features.statuses"
									:opacity="opacity"
									:variant="variant">
								
									<b-list-group-item 
										class="d-flex justify-content-between align-items-center"
										@click="over('statuses')">

										Status
										<b-icon icon="circle-half"/>
									</b-list-group-item>

									<template v-slot:overlay>
										{{featureText.statuses}}
									</template>

								</b-overlay>
								
								<b-overlay
									:show="features.subTasks"
									:opacity="opacity"
									:variant="variant">

									<b-list-group-item 
										class="d-flex justify-content-between align-items-center"
										@click="over('subTasks')">
										Sub-tasks
										<b-icon icon="file-plus"/>
									</b-list-group-item>

									<template v-slot:overlay>
										{{featureText.subTasks}}
									</template>
								</b-overlay>

							</b-list-group>

						</b-card-body>
					</b-col>
					
					<b-col 
						align-self="center"
						md="4"
						order="1"
						order-md="2">
						<b-card-img :src="require('../../assets/stock/checklist-1.jpg')" alt="Image" class="rounded-0"></b-card-img>
					</b-col>
					
				</b-row>
			</b-card>
		</b-col>
	</b-row>

	<b-row class="mt-5">
		<b-col>
			
			<b-card no-body class="overflow-hidden" style="border:none;">
				<b-row no-gutters>
					
					<b-col md="4">
						<b-card-img :src="require('../../assets/stock/deadline-3.jpg')" alt="Image" class="rounded-0"></b-card-img>
					</b-col>
					
					<b-col md="8" align-self="center">
						<b-card-body>
							<b-card-text>

								<h2 class="display-4">
									Never Miss a Deadline
								</h2>

								<p style="font-size:1.25em">
									Keep track of important dates, recurring tasks, and get reminders so you always complete your todos on time.
								</p>
							</b-card-text>

							<b-list-group>
						

								<b-overlay
									:show="features.dates"
									:opacity="opacity"
									:variant="variant">
									
									<b-list-group-item 
										class="d-flex justify-content-between align-items-center"
										@click="over('dates')">

										Dates
										<b-icon icon="calendar"/>
									</b-list-group-item>

									<template v-slot:overlay>
										{{featureText.dates}}
									</template>

								</b-overlay>

								<b-overlay
									:show="features.reminders"
									:opacity="opacity"
									:variant="variant">
									
									<b-list-group-item 
										class="d-flex justify-content-between align-items-center"
										@click="over('reminders')">

										Reminders
										<b-icon icon="alarm-fill"/>
									</b-list-group-item>

									<template v-slot:overlay>
										{{featureText.reminders}}
									</template>

								</b-overlay>

								<b-overlay
									:show="features.repeatingTasks"
									:opacity="opacity"
									:variant="variant">
									
									<b-list-group-item 
										class="d-flex justify-content-between align-items-center"
										@click="over('repeatingTasks')">

										Repeating Tasks
										<b-icon icon="arrow-repeat"/>
									</b-list-group-item>

									<template v-slot:overlay>
										{{featureText.repeatingTasks}}
									</template>

								</b-overlay>

							</b-list-group>

						</b-card-body>
					</b-col>
					
					
					
				</b-row>
			</b-card>
		</b-col>
	</b-row>

	<b-row class="mt-5">
		<b-col>
			
			<b-card no-body class="overflow-hidden" style="border:none;">
				<b-row no-gutters>
					
					<b-col 
						md="8" 
						align-self="center"
						order="2"
						order-md="1">
						<b-card-body>
							<b-card-text>

								<h2 class="display-4">
									Keep Things Moving
								</h2>

								<p style="font-size:1.25em">
									Principal Task provides also provides these useful features to ensure that you're easily able to organize and tackle your todos.
								</p>
							</b-card-text>

							<b-list-group>
						

								<b-overlay
									:show="features.filters"
									:opacity="opacity"
									:variant="variant">
									
									<b-list-group-item 
										class="d-flex justify-content-between align-items-center"
										@click="over('filters')">

										Custom Filters
										<b-icon icon="filter"/>
									</b-list-group-item>

									<template v-slot:overlay>
										{{featureText.filters}}
									</template>

								</b-overlay>

								<b-overlay
									:show="features.dashboard"
									:opacity="opacity"
									:variant="variant">
									
									<b-list-group-item 
										class="d-flex justify-content-between align-items-center"
										@click="over('dashboard')">

										Dashboard
										<b-icon icon="pie-chart-fill"/>
									</b-list-group-item>

									<template v-slot:overlay>
										{{featureText.dashboard}}
									</template>

								</b-overlay>
								
								<b-overlay
									:show="features.import"
									:opacity="opacity"
									:variant="variant">
									
									<b-list-group-item 
										class="d-flex justify-content-between align-items-center"
										@click="over('import')">

										Data Import
										<b-icon icon="box-arrow-down"/>
									</b-list-group-item>

									<template v-slot:overlay>
										{{featureText.import}}
									</template>

								</b-overlay>

								<b-overlay
									:show="features.kanban"
									:opacity="opacity"
									:variant="variant">
									
									<b-list-group-item 
										class="d-flex justify-content-between align-items-center"
										@click="over('kanban')">

										Kanban
										<b-icon icon="kanban"/>
									</b-list-group-item>

									<template v-slot:overlay>
										{{featureText.kanban}}
									</template>

								</b-overlay>

								<b-overlay
									:show="features.markdown"
									:opacity="opacity"
									:variant="variant">
									
									<b-list-group-item 
										class="d-flex justify-content-between align-items-center"
										@click="over('markdown')">

										Markdown
										<b-icon icon="markdown-fill"/>
									</b-list-group-item>

									<template v-slot:overlay>
										Format your comments with
										<b-link href="https://www.markdownguide.org/" target="_new">
										Markdown</b-link>
									</template>

								</b-overlay>

								<b-overlay
									:show="features.mobile"
									:opacity="opacity"
									:variant="variant">
									
									<b-list-group-item 
										class="d-flex justify-content-between align-items-center"
										@click="over('mobile')">

										Mobile-friendly
										<b-icon icon="phone"/>
									</b-list-group-item>

									<template v-slot:overlay>
										{{featureText.mobile}}
									</template>

								</b-overlay>

								<b-overlay
									:show="features.templatesGeneric"
									:opacity="opacity"
									:variant="variant">

									<b-list-group-item 
										class="d-flex justify-content-between align-items-center"
										@click="over('templatesGeneric')">
										
										Task Templates
										
										<b-icon icon="list"/>
									
									</b-list-group-item>

									<template v-slot:overlay>
										{{featureText.templatesGeneric}}
									</template>

								</b-overlay>

								<b-overlay
									:show="features.visibility"
									:opacity="opacity"
									:variant="variant">

									<b-list-group-item 
										class="d-flex justify-content-between align-items-center"
										@click="over('visibility')">
										
										Visibility
										
										<b-icon icon="arrows-expand"/>
									
									</b-list-group-item>

									<template v-slot:overlay>
										{{featureText.visibility}}
									</template>

								</b-overlay>

							</b-list-group>

						</b-card-body>
					</b-col>
					
					<b-col 
						align-self="center"
						md="4"
						order="1"
						order-md="2">
						<b-card-img :src="require('../../assets/stock/gears-1.jpg')" alt="Image" class="rounded-0"></b-card-img>
					</b-col>
					
				</b-row>
			</b-card>
		</b-col>
	</b-row>

	<b-row class="mt-5">
		<b-col>
			
			<b-card no-body class="overflow-hidden" style="border:none;">
				<b-row no-gutters>
					
					<b-col 
						align-self="center"
						md="4">
						<b-card-img :src="require('../../assets/stock/joinus-1.jpg')" alt="Image" class="rounded-0"></b-card-img>
					</b-col>
					
					<b-col md="8" align-self="center">
						<b-card-body>
							<b-card-text>

								<h2 class="display-4">
									Join Us
								</h2>

								<p style="font-size:1.25em">
								
									Join for free &mdash; no credit card required &mdash; and become more productive or  
									super-charge your productivity by becoming an early patron.

								</p>
								
							</b-card-text>

							<b-card-group deck>
                
                
  

                
                
								<b-card
									style="color:black">

									<h3 class="display-5">
									<b-link :to="{name: 'signup', params: {action: 'signup', tier: 'free'}}">Early Adopter</b-link>
									</h3>
									<h6 class="text-secondary">Free.</h6>

									<b-card-text>
									Over a dozen core features at no cost.
									</b-card-text>

									
								</b-card>

								<b-card
									style="color:black">
											
									<h3 class="display-5">
									<b-link :to="{name: 'signup', params: {action: 'signup', tier: 'paid'}}">Early Patron</b-link>
									</h3>
									
									<h6 class="text-secondary">As low as $2/month.</h6>
									
									<b-card-text>
									
									<p> All of the features of the free tier plus kanban boards and private templates.</p>
				

									</b-card-text>

									
								</b-card>

								</b-card-group>
							

						</b-card-body>
					</b-col>
					
					
					
				</b-row>

				
			</b-card>
		</b-col>
	</b-row>
	
	<b-row align-h="around" cols="12">
		<b-col cols="12"
			style="text-align:center;">
			<b-button :to="{name: 'signup', params: {action: 'signup'}}" 
                            variant="success" class="mt-3">Get Started</b-button>
		</b-col>
	</b-row>
	

</span>
</template>
<script>

	import Menu from '@/components/menus/Menu4.vue'
	import features from '@/mixins/features'

	export default {
		name: 'Landing4',
		metaInfo() {
			return {
				title: 'Principal Task | Modern Todo Software',
				meta: [
					{
						name: 'description',
						content: 'Principal Task is modern todo software for productive people (or those who want to be).'
					},
					{
						name: 'keywords',
						content: 'principal task, principal todo, tasks, task, task manager, task list, to-do, to do, todo, todo list, todo manager, todo software, todo software mac, todo software for windows, todo software mobile, todo software iphone, todo software android, best todo software, kanban, todo kanban'
					},
					{
						property: 'og:description',
						content: 'Principal Task is modern todo software for productive people (or those who want to be).'
					},
					{
						property: 'og:image',
						content: 'https://www.principaltask.com/img/PTLogo-Cropped-1.fafd2068.png'
					},
					{
						property: 'og:title',
						content: 'Principal Task | Modern Todo Software'
					},
					{
						property: 'og:type',
						content: 'website'
					},
					{
						name: 'twitter:card',
						content: 'summary_large_image'
					},
					{
						name: 'twitter:description',
						content: 'Principal Task is modern todo software for productive people (or those who want to be).'
					},
					{
						property: 'twitter:image',
						content: 'https://www.principaltask.com/img/PTLogo-Cropped-1.fafd2068.png'
					},
					{
						name: 'twitter:site',
						content: '@PrincipalTask'
					},
					{
						name: 'twitter:title',
						content: 'Principal Task'
					},
					
				]
			}
		},
		components: {
            Menu
		},
		mixins: [
			features,
		],
		props: {
		},
		data () {
			return {
				
			}
		},
		methods: {
			
		},    

}
</script>